import { Card, styled } from "@mui/material";

const StyledCard = styled(Card)(({ theme,department }) => ({
  
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[10], // or any custom shadow
    },
    boxShadow: theme.shadows[1],
    flexWrap: "wrap"
  }));


  const DepartmentCard = styled(Card)(({ theme }) => ({
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)", // Zoom effect on hover
      boxShadow: theme.shadows[4],
    },
    "&.active": {
      transform: "scale(1.05)", // Zoom effect when active
      boxShadow: theme.shadows[6], // Stronger shadow for active state
    },
  }));
  export { StyledCard ,DepartmentCard};
